// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a152ae02","558":"4d472186"}[chunkId] + ".chunk.js";
};